import { fireHeapEvent } from '../helpers'
import eventNames from '../constants/crm'

const e = {
  Flowpage_CRM_Clicked_AuthorizeInForm(): void {
    fireHeapEvent(eventNames.Flowpage_CRM_Clicked_AuthorizeInForm)
  },
  Flowpage_CRM_Clicked_ManagePageAfterGoogleAuth(): void {
    fireHeapEvent(eventNames.Flowpage_CRM_Clicked_ManagePageAfterGoogleAuth)
  }
}

export default e
